import React, { useEffect, useState, useRef } from "react";
import "../css/constants.css"
import { motion, useViewportScroll, useTransform } from "framer-motion";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FaArrowRight } from 'react-icons/fa';

import HeroImg from "../assets/images/hbg-arcs-1950-a-a-peignee-verticale-6436-1920x1080-f50_50.png";
import PicRow1 from "../assets/images/rapide.png";
import PicRow2 from "../assets/images/appel-telephonique.png";
import PicRow3 from "../assets/images/bouclier.png";
import Concierge1 from "../assets/images/Blade-Helicoptere-menton_upscayl_2x_realesrgan-x4plus.webp";
import Concierge2 from "../assets/images/H130_interior.jpg.webp";
import Concierge3 from "../assets/images/VALLE D'AOSTA-Heliski a Gressoney-(Società Guide Gressoney-Monte Rosa).jpg";
import Concierge4 from "../assets/images/agusta-a109s-grand-full-cabin-view.jpeg";
import Concierge5 from "../assets/images/helipad-jubilee_001.jpeg";
import Concierge6 from "../assets/images/luxury-helicopters-promo-1.avif";
import Concierge7 from "../assets/images/Thanda-Island-prywatne-wyspy-na-wynajem-najpiekniejsze-wyspy-w-Afryce-indywidualna-wycieczka-do-Afryki-wynajem-prywatnej-wyspy-wakacje-na-prywatnej-wyspie-11-1536x1022.jpeg";
import Concierge8 from "../assets/images/66d039c192a92ee8b565f543_Helicopter Charter Main Banner.webp";
import Concierge9 from "../assets/images/IMG_8636.jpeg";
import Transition from "../components/Transition";
import {useNavigate} from "react-router-dom";
import ConciergerieJson from "../assets/jsons/helicopter.json";
import FlightsJson from "../assets/jsons/helicopterFlights.json";
import ServicesJson from "../assets/jsons/services.json";
import TestimonialsJson from "../assets/jsons/testimonials.json";
import GlobalJson from "../assets/jsons/Global.json";

const GOLD = "#C1A45F";

const services = [
    {
        title: "Réactivité absolue",
        desc: "Nous répondons et organisons en quelques minutes, 24/7.",
        img: PicRow1,
    },
    {
        title: "Disponibilité sur-mesure",
        desc: "Un interlocuteur unique, présent à chaque étape.",
        img: PicRow2,
    },
    {
        title: "Discrétion & sécurité",
        desc: "Standards premium de sécurité et confidentialité.",
        img: PicRow3,
    },
];

const flights = [
    {
        title: "PARIS → GENÈVE",
        aircraft: "Citation CJ4 Light Jet",
        img: Concierge1,
        description: [
            "Le téléphone a sonné la veille au soir.",
            "Un rendez-vous d’affaires crucial devait être organisé à Genève...",
            "À 7h45, notre client arrive directement au Terminal privé du Bourget, sans file d'attente.",
        ],
        quote: "Une extension naturelle de sa journée, optimisée sans jamais forcer le rythme.",
    },
    {
        title: "NICE → IBIZA",
        aircraft: "Phenom 300",
        img: Concierge2,
        description: [
            "Une idée folle devient réalité : partir pour Ibiza cet après-midi.",
            "Cabine préparée : champagne millésimé, playlist lounge, pivoines fraîches.",
            "À l’atterrissage, une voiture les attend déjà à l’hôtel soigneusement réservé.",
        ],
        quote: "Une fugue élégante, improvisée, intense — une parenthèse enchantée.",
    },
    {
        title: "PARIS → NEW YORK",
        aircraft: "Gulfstream G650",
        img: Concierge3,
        description: [
            "Le lancement d'une filiale new-yorkaise : une traversée transformée en événement.",
            "Cabine métamorphosée : lits en coton égyptien, dîner gastronomique, animations pour enfants.",
            "À Teterboro, Manhattan scintille dans la nuit.",
        ],
        quote: "Un cocon d’attention, de douceur, d’élégance absolue.",
    },
];

const testimonials = [
    {
        name: "Lucien D.",
        role: "Dirigeant",
        quote:
            "Avanty Jet a transformé un déplacement banal en un moment d’exception. Discrétion, précision, excellence.",
    },
    {
        name: "Élodie S.",
        role: "Influenceuse voyage",
        quote:
            "Jamais je n’avais vécu un service aussi personnalisé — du sur-mesure à l’état pur.",
    },
];

function SectionTitle({ eyebrow, title, subtitle }) {
    return (
        <div className="text-center">
            {eyebrow && <p className="uppercase text-sm tracking-widest text-white/60 mb-2">{eyebrow}</p>}
            <h2 className="text-3xl sm:text-4xl font-extrabold" style={{ color: GOLD }}>{title}</h2>
            {subtitle && <p className="mt-3 text-white/80 max-w-4xl mx-auto">{subtitle}</p>}
        </div>
    );
}

function ImageCarousel({ images, height = "h-96" }) {
    const [index, setIndex] = useState(0);
    useEffect(() => {
        const t = setInterval(() => setIndex((i) => (i + 1) % images.length), 4500);
        return () => clearInterval(t);
    }, [images.length]);
    return (
        <div className="relative w-full rounded-2xl overflow-hidden shadow-xl">
            <img src={images[index]} alt={`carousel-${index}`} className={`w-full object-cover ${height}`}/>
            <div className="absolute bottom-4 left-4 flex gap-2">
                {images.map((_, i) => (
                    <button
                        key={i}
                        onClick={() => setIndex(i)}
                        className={`w-10 h-2 rounded-full ${i === index ? "bg-white" : "bg-white/40"}`}
                    />
                ))}
            </div>
        </div>
    );
}

function DemanderDevisButton({language}) {
    const navigate = useNavigate();

    return (
        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} className="flex justify-center cursor-pointer">
            <a
                onClick={() => navigate("/#quotation")}
                className="px-10 py-4 rounded-full bg-white text-black font-semibold shadow-lg flex items-center hover:bg-gray-100 transition"
            >
                {GlobalJson.availableLanguages[language].ctaButton}
                <FaArrowRight className="ml-2" />
            </a>
        </motion.div>
    );
}

export default function MainContent({ language, setLanguage }) {
    const { scrollY } = useViewportScroll();
    const y = useTransform(scrollY, [0, 600], [0, -120]);
    const navigate = useNavigate()

    return (
        <div className="min-h-screen bg-myDarkBlue text-white font-sans">
            <Navbar language={language} setLanguage={setLanguage} />

            {/* HERO */}
            {/* HERO */}
            <section className="relative h-screen flex items-center justify-center overflow-hidden">
                {/* Image + effet parallax */}
                <motion.div
                    style={{
                        y,
                        willChange: "transform",
                        backgroundImage: `url(${HeroImg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                    className="absolute inset-0 brightness-50"
                />

                {/* Filtre brightness séparé pour éviter de le recalculer à chaque scroll */}
                <div className="absolute inset-0 brightness-50" />

                {/* Dégradé */}
                <div className="absolute inset-0 bg-gradient-to-t from-myDarkBlue via-transparent to-myDarkBlue" />

                {/* Contenu */}
                <div className="relative z-20 max-w-5xl px-6 text-center">
                    <motion.h1
                        initial={{ y: -30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.8 }}
                        className="text-4xl sm:text-6xl font-serif leading-tight font-bold"
                        style={{ color: GOLD }}
                    >
                        {ConciergerieJson.availableLanguages[language].heroTitle}<br />{ConciergerieJson.availableLanguages[language].heroTitle2}
                    </motion.h1>

                    <motion.p
                        initial={{ y: 30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1 }}
                        className="mt-6 text-lg sm:text-xl max-w-3xl mx-auto text-white"
                    >
                        {ConciergerieJson.availableLanguages[language].heroSubtitle}
                    </motion.p>

                    <div className="mt-8 flex items-center justify-center gap-4 cursor-pointer">
                        <a
                            onClick={() => navigate("/#quotation")}
                            className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-white/85 text-black font-semibold shadow-2xl hover:scale-105 transition-transform"
                        >
                            {ConciergerieJson.availableLanguages[language].heroCTA.primary}
                        </a>
                    </div>
                </div>

                {/* subtle down arrow */}
                <div className="absolute bottom-8 z-30 w-full flex justify-center">
                    <motion.div animate={{ y: [0, 8, 0] }} transition={{ repeat: Infinity, duration: 1.6 }}>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 5v14" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M19 12l-7 7-7-7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </motion.div>
                </div>
            </section>

            <section className="relative py-24 bg-gradient-to-b from-myDarkBlue via-[#0f172a] to-myDarkBlue overflow-hidden">
                <div className="absolute inset-0">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.05),transparent_70%)]"></div>
                </div>

                <div className="relative max-w-7xl mx-auto px-6 flex flex-col gap-16 items-center">
                    {/* Titre de section */}
                    <SectionTitle
                        eyebrow={ConciergerieJson.availableLanguages[language].conciergerieEyebrow}
                        title={ConciergerieJson.availableLanguages[language].conciergerieTitle}
                        subtitle={ConciergerieJson.availableLanguages[language].conciergerieSubtitle}
                    />

                    {/* Bloc principal */}
                    <motion.div
                        className="w-full bg-white/5 backdrop-blur-md border border-white/10 rounded-3xl shadow-2xl p-8 md:p-14 relative overflow-hidden"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        {/* Décoration glow */}
                        <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#C1A45F]/20 rounded-full blur-3xl"></div>
                        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl"></div>

                        {/* Introduction */}
                        <p className="text-white/90 text-lg leading-relaxed max-w-3xl mx-auto mb-14 text-center">
                            {ConciergerieJson.availableLanguages[language].conciergerieIntro}
                        </p>

                        {/* Grille responsive */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                            {/* Carrousel gauche */}
                            <div className="flex flex-col gap-6 relative">
                                <ImageCarousel images={[Concierge4, Concierge5, Concierge6]} />
                            </div>

                            {/* Détails et CTA */}
                            <div className="flex flex-col justify-center space-y-8 text-white/80">
                                <ul className="space-y-4">
                                    {ConciergerieJson.availableLanguages[language].conciergerieList.map((item, index) => (
                                        <li
                                            key={index}
                                            className="flex items-start gap-3 text-base md:text-lg group"
                                        >
                                            <span className="w-3 h-3 mt-2 rounded-full bg-[#C1A45F] group-hover:scale-110 transition"></span>
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* Séparateur */}
                        <div className="border-t border-[#C1A45F]/40 mt-16 mb-12 w-3/4 mx-auto" />

                        {/* CTA */}
                        <div className="flex justify-center mb-14">
                            <motion.a
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.98 }}
                                onClick={() => navigate("/#quotation")}
                                className="px-10 py-4 cursor-pointer rounded-full bg-gradient-to-r from-[#C1A45F] to-[#b2964f] text-black font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
                            >
                                {ConciergerieJson.availableLanguages[language].conciergerieCTA.primary}
                            </motion.a>
                        </div>

                        {/* Second carrousel */}
                        {/* Masonry style */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
                            {[Concierge9, Concierge8, Concierge7].map((img, i) => (
                                <div
                                    key={i}
                                    className="overflow-hidden rounded-2xl shadow-lg group relative"
                                >
                                    <img
                                        src={img}
                                        alt={`Helicopter ${i}`}
                                        className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-105"
                                    />
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </section>


            {/* IMMERSIVE STORIES */}
            <section className="py-24">
                <div className={"mb-14"}>
                    <SectionTitle
                        title={FlightsJson.availableLanguages[language].sectionTitle}
                    />
                </div>
                <div className="max-w-7xl mx-auto px-6 space-y-20">
                    {flights.map((f, idx) => (
                        <motion.div
                            key={idx}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            className={`flex flex-col lg:flex-row items-center gap-10 ${idx % 2 === 1 ? "lg:flex-row-reverse" : ""}`}
                        >
                            <div className="lg:w-1/2 rounded-3xl overflow-hidden shadow-2xl">
                                <img src={f.img} alt={f.title} className="w-full h-96 object-cover transform transition-transform hover:scale-105" />
                            </div>

                            <div className="lg:w-1/2 space-y-4">
                                <p className="text-sm uppercase tracking-wide text-white/60">{FlightsJson.availableLanguages[language].flights[idx].aircraft}</p>
                                <h3 className="text-2xl font-bold">{FlightsJson.availableLanguages[language].flights[idx].title}</h3>
                                <div className="text-white/75 space-y-2">
                                    {FlightsJson.availableLanguages[language].flights[idx].description.map((d, i) => (
                                        <p key={i}>{d}</p>
                                    ))}
                                </div>
                                <motion.div
                                    whileHover={{ scale: 1.02 }}
                                >
                                    <blockquote
                                        className="mt-4 italic border-l-4 pl-4 border-white/20 bg-black/20 text-white/80"
                                        style={{ borderColor: GOLD}}
                                    >
                                        “{FlightsJson.availableLanguages[language].flights[idx].quote}”
                                    </blockquote>
                                </motion.div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </section>

            {/* BRAND PROMISE */}
            <section className="pt-28 pb-16 bg-gradient-to-b from-myDarkBlue via-[#0f172a] to-myDarkBlue">
                <div className="max-w-7xl mx-auto px-6">
                    <SectionTitle
                        eyebrow={ServicesJson.availableLanguages[language].title1}
                        title={ServicesJson.availableLanguages[language].title2}
                        subtitle={ServicesJson.availableLanguages[language].title3}
                    />

                    <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
                        {services.map((s, i) => (
                            <motion.div
                                key={i}
                                whileHover={{ y: -6 }}
                                className="p-6 rounded-2xl bg-black/20 border border-white/20 shadow-lg "
                                style={{
                                    boxShadow: `
    0 -6px 10px rgba(255, 255, 255, 0.1),
    0 -8px 20px rgba(255, 255, 255, 0.05)
  `
                                }}
                            >
                                <div className="flex items-center gap-4">
                                    <img src={s.img} alt={s.title} className="w-16 h-16" />
                                    <div>
                                        <h4 className="text-xl font-semibold text-white">{ServicesJson.availableLanguages[language].services[i].title}</h4>
                                        <p className="text-white/75 mt-1">{ServicesJson.availableLanguages[language].services[i].desc}</p>
                                    </div>
                                </div>
                                <div className="mt-6 text-sm text-white/60 flex justify-center">
                                    {ServicesJson.availableLanguages[language].services[i].bottom}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* TESTIMONIALS */}
            <section className="py-16">
                <div className="max-w-7xl mx-auto px-6 text-center">
                    <SectionTitle eyebrow={TestimonialsJson.availableLanguages[language].title} title={TestimonialsJson.availableLanguages[language].subtitle} />

                    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
                        {testimonials.map((t, i) => (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                whileHover={{ y: -6 }}
                                viewport={{ once: true }}
                                className="relative p-6 rounded-2xl bg-black/20 border border-white/10 overflow-hidden bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.05),transparent_70%)]"
                                style={{
                                    boxShadow: `
    0 -6px 10px rgba(255, 255, 255, 0.1),
    0 -8px 20px rgba(255, 255, 255, 0.05)
  `
                                }}
                            >
                                <div
                                    className="absolute -top-4 left-0 w-full h-4 pointer-events-none"
                                    style={{
                                        boxShadow: "0 0 10px 2px rgba(255, 255, 255, 0.2)",
                                        maskImage: "linear-gradient(to bottom, white, transparent)",
                                        WebkitMaskImage: "linear-gradient(to bottom, white, transparent)"
                                    }}
                                />

                                <p className="italic text-white/80">{TestimonialsJson.availableLanguages[language].testimonials[i].quote}</p>
                                <p className="mt-4 font-semibold text-white">{TestimonialsJson.availableLanguages[language].testimonials[i].author}</p>
                                <p className="text-sm text-white/60">{TestimonialsJson.availableLanguages[language].testimonials[i].role}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FINAL CTA */}
            <section className="pt-10 pb-32 bg-myDarkBlue text-center">
                <h2 className="text-4xl font-extrabold mb-4" style={{ color: GOLD }}>{GlobalJson.availableLanguages[language].ctaTitle}</h2>
                <p className="text-white/80 max-w-2xl mx-auto mb-8">{GlobalJson.availableLanguages[language].contact}</p>
                <div className="flex items-center justify-center gap-4">
                    <DemanderDevisButton language={language}/>
                </div>
            </section>

            <Footer language={language} />
        </div>
    );
}

export function Helicopter({language, setLanguage}) {
    const [isTransitionVisible, setIsTransitionVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsTransitionVisible(false);
        }, 800);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            {isTransitionVisible ? (
                <Transition/>
            ) : (
                <MainContent language={language} setLanguage={setLanguage}/>
            )}
        </div>
    );
}